export const SUCCESS_STATUS_PILL = 0;

export const DANGER_STATUS_PILL = 1;

export const WARNING_STATUS_PILL = 2;

export const INFO_STATUS_PILL = 3;
